export default __webpack_public_path__ + "static/ProximaNova-Thin-d93a9cea39d6c420d1d6e1bc24a7282f.woff2";